import { render, staticRenderFns } from "./Resend.htm?vue&type=template&id=31f3d1df&scoped=true&"
import script from "./Resend.js?vue&type=script&lang=js&"
export * from "./Resend.js?vue&type=script&lang=js&"
import style0 from "./Resend.scss?vue&type=style&index=0&id=31f3d1df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3d1df",
  null
  
)

export default component.exports